import { Mention } from './mention.js'

export * from './mention.js'

export default Mention
